export const defaultMapBox = { id: 0, name: 'delete', effects: [] }
export const defaultMainStats = {
    level: 0,
    experience: 0,
    population: 0,
    happiness: 0,
    simoleons: 100000
}

export const defaultBuildingStats = {
    residentials: 0,
    parks: 0,
    police: 0,
    firehouse: 0,
    hospitals: 0,
    residual_waters: 0,
    waste_plants: 0,
    electric_plants: 0,
}

export const effectClass = {
    id: '',
    factor: 0,
    parentId: '',
    type: ''
}